<template>
  <card-groups class="_mb-sm-40 _mb-md-60">
    <card-box>
      <card-header>
        <btn-toggle v-b-toggle="accordionName" class="-plus">
          <h2 class="heading">撮影時のポイント</h2>
        </btn-toggle>
      </card-header>

      <collapse-item :id="accordionName" :accordion="accordionName" visible="true">
        <card-body>
          <div class="row">
            <div class="point-img col-12 col-md-6 _mb-15">
              <p class="txt01 _mb-md-30"><img src="@/assets/images/icons/circle-orange.svg" class="img-fluid _mr-md-20" alt="">よい例</p>
              <div class="img-box">
                <img src="@/assets/images/en/en008/img01.jpg" class="img-fluid _mr-1" alt=""><img src="@/assets/images/en/en008/img02.jpg" class="img-fluid _ml-1" alt="">
              </div>
              <list-group class="-normal">
                <list-item class="-normal">文字がはっきり読める</list-item>
                <list-item class="-normal">書類全体が写っている</list-item>
              </list-group>
            </div>
            <div class="point-img col-12 col-md-6 _mb-15">
              <p class="txt01 _mb-md-30"><img src="@/assets/images/icons/close-gray.svg" class="img-fluid _mr-md-20" alt="">悪い例</p>
              <div class="img-box">
                <img src="@/assets/images/en/en008/img03.jpg" class="img-fluid _mr-1" alt=""><img src="@/assets/images/en/en008/img04.jpg" class="img-fluid _ml-1" alt="">
              </div>
              <list-group class="-normal">
                <list-item class="-normal">画像がぼやけている</list-item>
                <list-item class="-normal">写真が切れている</list-item>
              </list-group>
            </div>
          </div>
          <list-group class="-note">
            <list-item class="-note">画像はイメージになります。</list-item>
            <list-item class="-note">画像に不備がある場合、お電話を差し上げることがございます。</list-item>
          </list-group>
        </card-body>
      </collapse-item>
    </card-box>
  </card-groups>
</template>

<script>
import CollapseItem from '../collapse/CollapseItem'
import CardBody from '../card/CardBody'
import HeadingThree from '../heading/HeadingThree'
import ListGroup from '../list/ListGroup'
import ListItem from '../list/ListItem'
import CardGroups from '../card/CardGroups'
import CardBox from '../card/CardBox'
import CardHeader from '../card/CardHeader'
import BtnToggle from '../button/BtnToggle'

export default {
  name: 'identity-point',
  components: {
    BtnToggle,
    CardHeader,
    CardBox,
    CardGroups,
    ListItem,
    ListGroup,
    HeadingThree,
    CardBody,
    CollapseItem
  },
  props: {
    accordionType: {type: String}
  },
  computed: {
    accordionName () {
      let result = 'accordion'
      if (this.accordionType) {
        result = result + '_' + this.accordionType
      } else {
        result = result + '0'
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";

  .point-img {
    width: 100%;
    @include mq-up(md) {
      width: 50%;
    }
    >.heading-three {
      >.heading {
        >.-icon {
          color: #eb5505;
          font-size: 26px;
          font-weight: bold;
        }
      }
    }
    >.img-box {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;
      img {
        width: 50%;
      }
    }
    >.txt01 {
      width: 100%;
      display: flex;
      align-items: center;
      font-weight: bold;
      img {
        width: 20px;
        @include mq-up(md) {
          width: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/IdentityPoint.vue